var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: { akinon: _vm.akinonEnabled },
      attrs: { id: "storyList" },
      on: { paste: _vm.handlePaste },
    },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _vm.multiDeleteMode
            ? _c("div", { staticClass: "multi-delete-bar" }, [
                _c(
                  "section",
                  {
                    staticClass: "uncheck",
                    on: { click: _vm.resetSelectedStories },
                  },
                  [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v(" arrow_back "),
                    ]),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("chatbotv2.uncheckAll")) +
                        "\n            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "section",
                  {
                    staticClass: "select",
                    on: { click: _vm.selectAllStories },
                  },
                  [_vm._v(_vm._s(_vm.$t("chatbotv2.selectAll")))]
                ),
                _vm._v(" "),
                _c("section", { staticClass: "queries" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$t("chatbotv2.selectedStory", {
                          count: _vm.selectedStories.length,
                        })
                      ) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c("section", { staticClass: "actions" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                          },
                          expression:
                            "{ followCursor: true, placement: 'bottom-end' }",
                        },
                      ],
                      attrs: { content: _vm.$t("chatbotv2.delete") },
                      on: {
                        click: function ($event) {
                          return _vm.showDeleteConfirmation()
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "material-icons" }, [
                        _vm._v(" delete "),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                          },
                          expression:
                            "{ followCursor: true, placement: 'bottom-end' }",
                        },
                      ],
                      staticClass: "actions",
                      attrs: { content: _vm.$t("message.cancel") },
                      on: { click: _vm.resetSelectedStories },
                    },
                    [
                      _c("span", { staticClass: "material-icons" }, [
                        _vm._v(" close "),
                      ]),
                    ]
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.modalVisible
            ? _c("div", [
                _c("div", { staticClass: "big-title-container" }, [
                  _c("div", { staticClass: "big-title" }, [
                    _vm._v(_vm._s(_vm.$t("chatbotv2.allSecnario"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "search-and-filters" },
                    [
                      _c("a-input-search", {
                        staticStyle: { width: "250px" },
                        attrs: { placeholder: _vm.$t("message.search") },
                        on: { change: _vm.handleSearch },
                        model: {
                          value: _vm.searchQuery,
                          callback: function ($$v) {
                            _vm.searchQuery = $$v
                          },
                          expression: "searchQuery",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "a-button-group",
                        { staticClass: "platform-filters" },
                        [
                          _c(
                            "a-button",
                            {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    followCursor: true,
                                    placement: "top-center",
                                  },
                                  expression:
                                    "{ followCursor: true, placement: 'top-center' }",
                                },
                              ],
                              staticClass: "platform-button integration-icons",
                              class: {
                                active: _vm.selectedPlatforms.includes("web"),
                              },
                              attrs: { content: "Web" },
                              on: {
                                click: function ($event) {
                                  return _vm.togglePlatform("web")
                                },
                              },
                            },
                            [
                              _c("SupsisIcon", {
                                staticStyle: { width: "16px", height: "16px" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "a-button",
                            {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    followCursor: true,
                                    placement: "top-center",
                                  },
                                  expression:
                                    "{ followCursor: true, placement: 'top-center' }",
                                },
                              ],
                              staticClass: "platform-button integration-icons",
                              class: {
                                active:
                                  _vm.selectedPlatforms.includes("telegram"),
                              },
                              attrs: { content: "Telegram (BotFather)" },
                              on: {
                                click: function ($event) {
                                  return _vm.togglePlatform("telegram")
                                },
                              },
                            },
                            [
                              _c("TelegramIcon", {
                                staticStyle: { width: "16px", height: "16px" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "a-button",
                            {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    followCursor: true,
                                    placement: "top-center",
                                  },
                                  expression:
                                    "{ followCursor: true, placement: 'top-center' }",
                                },
                              ],
                              staticClass: "platform-button integration-icons",
                              class: {
                                active:
                                  _vm.selectedPlatforms.includes("whatsapp"),
                              },
                              attrs: { content: "Whatsapp QR Kanalları" },
                              on: {
                                click: function ($event) {
                                  return _vm.togglePlatform("whatsapp")
                                },
                              },
                            },
                            [
                              _c("WhatsappIcon", {
                                staticStyle: { width: "16px", height: "16px" },
                                attrs: {
                                  specialBackgroundMode: true,
                                  color: "#28AC01",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "a-button",
                            {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    followCursor: true,
                                    placement: "top-center",
                                  },
                                  expression:
                                    "{ followCursor: true, placement: 'top-center' }",
                                },
                              ],
                              staticClass: "platform-button integration-icons",
                              class: {
                                active: _vm.selectedPlatforms.includes(
                                  "whatsapp-business-api"
                                ),
                              },
                              attrs: { content: "Whatsapp Business API" },
                              on: {
                                click: function ($event) {
                                  return _vm.togglePlatform(
                                    "whatsapp-business-api"
                                  )
                                },
                              },
                            },
                            [
                              _c("WhatsappBusinessIcon", {
                                staticStyle: { width: "16px", height: "16px" },
                                attrs: {
                                  specialBackgroundMode: true,
                                  color: "#28AC01",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "a-button",
                            {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    followCursor: true,
                                    placement: "top-center",
                                  },
                                  expression:
                                    "{ followCursor: true, placement: 'top-center' }",
                                },
                              ],
                              staticClass: "platform-button integration-icons",
                              class: {
                                active:
                                  _vm.selectedPlatforms.includes("messenger"),
                              },
                              attrs: { content: "Messenger" },
                              on: {
                                click: function ($event) {
                                  return _vm.togglePlatform("messenger")
                                },
                              },
                            },
                            [
                              _c("MessengerIcon", {
                                staticStyle: { width: "16px", height: "16px" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "a-button",
                            {
                              staticClass: "platform-button integration-icons",
                              class: {
                                active:
                                  _vm.selectedPlatforms.includes("instagram"),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.togglePlatform("instagram")
                                },
                              },
                            },
                            [
                              _c("InstagramIcon", {
                                staticStyle: { width: "16px", height: "16px" },
                                attrs: {
                                  specialBackgroundMode: true,
                                  color: "#28AC01",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "a-button",
                            {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    followCursor: true,
                                    placement: "top-center",
                                  },
                                  expression:
                                    "{ followCursor: true, placement: 'top-center' }",
                                },
                              ],
                              staticClass: "platform-button integration-icons",
                              class: {
                                active:
                                  _vm.selectedPlatforms.includes("linkedin"),
                              },
                              attrs: { content: "Linkedin" },
                              on: {
                                click: function ($event) {
                                  return _vm.togglePlatform("linkedin")
                                },
                              },
                            },
                            [
                              _c("LinkedinIcon", {
                                staticStyle: { width: "16px", height: "16px" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "a-button",
                            {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    followCursor: true,
                                    placement: "top-center",
                                  },
                                  expression:
                                    "{ followCursor: true, placement: 'top-center' }",
                                },
                              ],
                              staticClass: "platform-button integration-icons",
                              class: {
                                active:
                                  _vm.selectedPlatforms.includes("telegram-qr"),
                              },
                              attrs: { content: "Telegram QR" },
                              on: {
                                click: function ($event) {
                                  return _vm.togglePlatform("telegram-qr")
                                },
                              },
                            },
                            [
                              _c("TelegramIcon", {
                                staticStyle: { width: "16px", height: "16px" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "a-button",
                            {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    followCursor: true,
                                    placement: "top-center",
                                  },
                                  expression:
                                    "{ followCursor: true, placement: 'top-center' }",
                                },
                              ],
                              staticClass: "platform-button integration-icons",
                              class: {
                                active:
                                  _vm.selectedPlatforms.includes("trendyol"),
                              },
                              attrs: { content: "Trendyol" },
                              on: {
                                click: function ($event) {
                                  return _vm.togglePlatform("trendyol")
                                },
                              },
                            },
                            [
                              _c("TrendyolIcon", {
                                staticStyle: { width: "16px", height: "16px" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "stories" },
                  [
                    _vm.checkPermission(
                      _vm.PERMISSION_TYPES["chatbot.stories.create"].tr.name
                    )
                      ? _c(
                          "div",
                          {
                            staticClass: "story story-add",
                            attrs: { md: "3" },
                            on: {
                              click: function () {
                                return (_vm.modalVisible = true)
                              },
                            },
                          },
                          [
                            _c("a-icon", {
                              staticStyle: { "font-size": "30px" },
                              attrs: { type: "plus-circle", theme: "filled" },
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "text-large font-weight-bolder mt-2",
                                staticStyle: {
                                  "font-size": "20px",
                                  "letter-spacing": "2px",
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("chatbotv2.addBot")))]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.loading
                      ? _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          _vm._l(3, function (skltn) {
                            return _c(
                              "div",
                              {
                                key: skltn,
                                staticClass: "story story-add mx-2 p-3",
                                staticStyle: { background: "white !important" },
                                attrs: { md: "3" },
                              },
                              [
                                _c("a-skeleton", {
                                  attrs: {
                                    active: true,
                                    paragraph: { rows: 3 },
                                  },
                                }),
                              ],
                              1
                            )
                          }),
                          0
                        )
                      : _vm._l(_vm.displayedStories, function (story) {
                          return _c(
                            "a",
                            {
                              key: story.id,
                              staticClass: "story",
                              class: {
                                selected: _vm.isStorySelected(story.id),
                              },
                              attrs: { md: "3", href: _vm.getStoryHref(story) },
                              on: {
                                click: function ($event) {
                                  return _vm.handleStoryClick(story, $event)
                                },
                              },
                            },
                            [
                              _vm.multiDeleteMode
                                ? _c("div", {
                                    staticClass: "transparent-area",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.addSelectedStories(story.id)
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.multiDeleteMode
                                ? _c("span", [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.selectedStories,
                                          expression: "selectedStories",
                                        },
                                      ],
                                      staticClass:
                                        "custom-checkbox-multi-delete",
                                      attrs: {
                                        type: "checkbox",
                                        id: "checkbox-" + story.id,
                                      },
                                      domProps: {
                                        value: story.id,
                                        checked: Array.isArray(
                                          _vm.selectedStories
                                        )
                                          ? _vm._i(
                                              _vm.selectedStories,
                                              story.id
                                            ) > -1
                                          : _vm.selectedStories,
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                        },
                                        change: function ($event) {
                                          var $$a = _vm.selectedStories,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = story.id,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.selectedStories =
                                                  $$a.concat([$$v]))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.selectedStories = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.selectedStories = $$c
                                          }
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("label", {
                                      staticClass: "custom-label-multi-delete",
                                      attrs: { for: "checkbox-" + story.id },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                        },
                                      },
                                    }),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isForwardedToWeb(story) ||
                              _vm.isForwardedToWhatsapp(story.id) ||
                              _vm.isForwardedToWhatsappApi(story.id) ||
                              _vm.isForwardedToInstagram(story.id) ||
                              _vm.isForwardedToMessenger(story.id) ||
                              _vm.isForwardedToTrendyol(story.id) ||
                              _vm.isForwardedToLinkedin(story.id) ||
                              _vm.isForwardedToTelegramQR(story.id)
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "ribbon w-100 m-2 text-dark",
                                      on: {
                                        click: function (e) {
                                          e.stopPropagation()
                                        },
                                      },
                                    },
                                    [
                                      _c("span", [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("chatbotv2.integratedWith")
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          [
                                            _vm._l(
                                              _vm.getKeysOfIntegrations(story),
                                              function (item, index) {
                                                return _c(
                                                  "span",
                                                  [
                                                    item === "supsisWidget" &&
                                                    _vm.isForwardedToWeb(story)
                                                      ? _c("SupsisIcon", {
                                                          directives: [
                                                            {
                                                              name: "tippy",
                                                              rawName:
                                                                "v-tippy",
                                                              value: {
                                                                followCursor: true,
                                                                placement:
                                                                  "top-center",
                                                              },
                                                              expression:
                                                                "{ followCursor: true, placement: 'top-center' }",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "integration-icons pt-2",
                                                          attrs: {
                                                            content:
                                                              "Supsis Widget",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    item === "telegram" &&
                                                    _vm.getValueOfIntegrations(
                                                      story
                                                    )[index] === true
                                                      ? _c("TelegramIcon", {
                                                          directives: [
                                                            {
                                                              name: "tippy",
                                                              rawName:
                                                                "v-tippy",
                                                              value: {
                                                                followCursor: true,
                                                                placement:
                                                                  "top-center",
                                                              },
                                                              expression:
                                                                "{ followCursor: true, placement: 'top-center' }",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "integration-icons pt-2",
                                                          attrs: {
                                                            specialBackgroundMode: true,
                                                            content: "Telegram",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    item === "facebook" &&
                                                    _vm.getValueOfIntegrations(
                                                      story
                                                    )[index] === true
                                                      ? _c("FacebookIcon", {
                                                          directives: [
                                                            {
                                                              name: "tippy",
                                                              rawName:
                                                                "v-tippy",
                                                              value: {
                                                                followCursor: true,
                                                                placement:
                                                                  "top-center",
                                                              },
                                                              expression:
                                                                "{ followCursor: true, placement: 'top-center' }",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "integration-icons pt-2",
                                                          attrs: {
                                                            content: "Facebook",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    item === "twitter" &&
                                                    _vm.getValueOfIntegrations(
                                                      story
                                                    )[index] === true
                                                      ? _c("TwitterIcon", {
                                                          directives: [
                                                            {
                                                              name: "tippy",
                                                              rawName:
                                                                "v-tippy",
                                                              value: {
                                                                followCursor: true,
                                                                placement:
                                                                  "top-center",
                                                              },
                                                              expression:
                                                                "{ followCursor: true, placement: 'top-center' }",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "integration-icons pt-2",
                                                          attrs: {
                                                            content: "Twitter",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    item === "slack" &&
                                                    _vm.getValueOfIntegrations(
                                                      story
                                                    )[index] === true
                                                      ? _c("SlackIcon", {
                                                          directives: [
                                                            {
                                                              name: "tippy",
                                                              rawName:
                                                                "v-tippy",
                                                              value: {
                                                                followCursor: true,
                                                                placement:
                                                                  "top-center",
                                                              },
                                                              expression:
                                                                "{ followCursor: true, placement: 'top-center' }",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "integration-icons pt-2",
                                                          attrs: {
                                                            content: "Slack",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    item === "skype" &&
                                                    _vm.getValueOfIntegrations(
                                                      story
                                                    )[index] === true
                                                      ? _c("SkypeIcon", {
                                                          directives: [
                                                            {
                                                              name: "tippy",
                                                              rawName:
                                                                "v-tippy",
                                                              value: {
                                                                followCursor: true,
                                                                placement:
                                                                  "top-center",
                                                              },
                                                              expression:
                                                                "{ followCursor: true, placement: 'top-center' }",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "integration-icons pt-2",
                                                          attrs: {
                                                            content: "Skype",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    item === "shopify" &&
                                                    _vm.getValueOfIntegrations(
                                                      story
                                                    )[index] === true
                                                      ? _c("ShopifyIcon", {
                                                          directives: [
                                                            {
                                                              name: "tippy",
                                                              rawName:
                                                                "v-tippy",
                                                              value: {
                                                                followCursor: true,
                                                                placement:
                                                                  "top-center",
                                                              },
                                                              expression:
                                                                "{ followCursor: true, placement: 'top-center' }",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "integration-icons pt-2",
                                                          attrs: {
                                                            content: "Shopify",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              [
                                                _vm.isForwardedToWhatsapp(
                                                  story.id
                                                )
                                                  ? _c("WhatsappIcon", {
                                                      directives: [
                                                        {
                                                          name: "tippy",
                                                          rawName: "v-tippy",
                                                          value: {
                                                            followCursor: true,
                                                            placement:
                                                              "top-center",
                                                          },
                                                          expression:
                                                            "{ followCursor: true, placement: 'top-center' }",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "integration-icons pt-2",
                                                      attrs: {
                                                        specialBackgroundMode: true,
                                                        content: "Whatsapp",
                                                        color: "#28AC01",
                                                      },
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.isForwardedToWhatsappApi(
                                                  story.id
                                                )
                                                  ? _c("WhatsappBusinessIcon", {
                                                      directives: [
                                                        {
                                                          name: "tippy",
                                                          rawName: "v-tippy",
                                                          value: {
                                                            followCursor: true,
                                                            placement:
                                                              "top-center",
                                                          },
                                                          expression:
                                                            "{ followCursor: true, placement: 'top-center' }",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "integration-icons pt-2",
                                                      attrs: {
                                                        specialBackgroundMode: true,
                                                        content:
                                                          "Whatsapp Business API",
                                                        color: "#28AC01",
                                                      },
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.isForwardedToInstagram(
                                                  story.id
                                                )
                                                  ? _c("InstagramIcon", {
                                                      directives: [
                                                        {
                                                          name: "tippy",
                                                          rawName: "v-tippy",
                                                          value: {
                                                            followCursor: true,
                                                            placement:
                                                              "top-center",
                                                          },
                                                          expression:
                                                            "{ followCursor: true, placement: 'top-center' }",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "integration-icons pt-2",
                                                      attrs: {
                                                        specialBackgroundMode: true,
                                                        content: "Instagram",
                                                      },
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.isForwardedToMessenger(
                                                  story.id
                                                )
                                                  ? _c("MessengerIcon", {
                                                      directives: [
                                                        {
                                                          name: "tippy",
                                                          rawName: "v-tippy",
                                                          value: {
                                                            followCursor: true,
                                                            placement:
                                                              "top-center",
                                                          },
                                                          expression:
                                                            "{ followCursor: true, placement: 'top-center' }",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "integration-icons pt-2",
                                                      attrs: {
                                                        specialBackgroundMode: true,
                                                        content: "Messenger",
                                                      },
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.isForwardedToLinkedin(
                                                  story.id
                                                )
                                                  ? _c("LinkedinIcon", {
                                                      directives: [
                                                        {
                                                          name: "tippy",
                                                          rawName: "v-tippy",
                                                          value: {
                                                            followCursor: true,
                                                            placement:
                                                              "top-center",
                                                          },
                                                          expression:
                                                            "{ followCursor: true, placement: 'top-center' }",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "integration-icons pt-2",
                                                      attrs: {
                                                        specialBackgroundMode: true,
                                                        content: "Linkedin",
                                                      },
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.isForwardedToTelegramQR(
                                                  story.id
                                                )
                                                  ? _c("TelegramIcon", {
                                                      directives: [
                                                        {
                                                          name: "tippy",
                                                          rawName: "v-tippy",
                                                          value: {
                                                            followCursor: true,
                                                            placement:
                                                              "top-center",
                                                          },
                                                          expression:
                                                            "{ followCursor: true, placement: 'top-center' }",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "integration-icons pt-2",
                                                      attrs: {
                                                        specialBackgroundMode: true,
                                                        content: "Telegram QR",
                                                      },
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.isForwardedToTrendyol(
                                                  story.id
                                                )
                                                  ? _c("TrendyolIcon", {
                                                      directives: [
                                                        {
                                                          name: "tippy",
                                                          rawName: "v-tippy",
                                                          value: {
                                                            followCursor: true,
                                                            placement:
                                                              "top-center",
                                                          },
                                                          expression:
                                                            "{ followCursor: true, placement: 'top-center' }",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "integration-icons pt-2",
                                                      attrs: {
                                                        specialBackgroundMode: true,
                                                        content: "Trendyol",
                                                      },
                                                    })
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                          ],
                                          2
                                        ),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "a-popover",
                                {
                                  staticClass: "story-menu-content px-3",
                                  attrs: {
                                    id: "story-menu-popover",
                                    trigger: "click",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "story-menu-popover-items",
                                          on: {
                                            click: function ($event) {
                                              _vm.$router.push(
                                                "/chatbot/story/" +
                                                  story.id +
                                                  "/" +
                                                  _vm.getDraftVersion(story)
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            [
                                              _c("a-icon", {
                                                staticClass: "px-1",
                                                attrs: { type: "edit" },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              attrs: { slot: "content" },
                                              slot: "content",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("message.edit"))
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("hr", {
                                        staticStyle: {
                                          "margin-bottom": "0.2rem",
                                          "margin-top": "0.2rem",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "story-menu-popover-items",
                                          on: {
                                            click: function ($event) {
                                              return _vm.duplicateAStory(story)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            [
                                              _c("a-icon", {
                                                staticClass: "px-1",
                                                attrs: { type: "switcher" },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              attrs: { slot: "content" },
                                              slot: "content",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("message.duplicate")
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("hr", {
                                        staticStyle: {
                                          "margin-bottom": "0.2rem",
                                          "margin-top": "0.2rem",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _vm.checkPermission(
                                        _vm.PERMISSION_TYPES[
                                          "chatbot.stories.delete"
                                        ].tr.name
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "story-menu-popover-items",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.multiDeleteModeOpen(
                                                    story.id
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                [
                                                  _c("a-icon", {
                                                    staticClass: "px-1",
                                                    attrs: { type: "delete" },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  attrs: { slot: "content" },
                                                  slot: "content",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("message.delete")
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("hr", {
                                        staticStyle: {
                                          "margin-bottom": "0.2rem",
                                          "margin-top": "0.2rem",
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a-button",
                                    {
                                      staticClass: "chatbot-btn",
                                      staticStyle: {
                                        "margin-left": "auto",
                                        "font-weight": "bolder",
                                        "letter-spacing": "2px",
                                        "font-size": "20px",
                                      },
                                      on: {
                                        click: function (e) {
                                          return e.stopPropagation()
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(story.name) +
                                          "\n                            "
                                      ),
                                      !_vm.multiDeleteMode
                                        ? _c("span", [_vm._v("...")])
                                        : _vm._e(),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex flex-column justify-content-between px-3 graph-alignment",
                                },
                                [
                                  _c("div", { staticClass: "title" }, [
                                    _vm._v(_vm._s(story.title)),
                                  ]),
                                  _vm._v(" "),
                                  _vm.$_.isEmpty(story.description)
                                    ? _c("span", [
                                        _vm._v(_vm._s(story.description)),
                                      ])
                                    : _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "tippy",
                                              rawName: "v-tippy",
                                              value: {
                                                followCursor: true,
                                                placement: "top-center",
                                              },
                                              expression:
                                                "{ followCursor: true, placement: 'top-center' }",
                                            },
                                          ],
                                          staticClass:
                                            "description text-shorten",
                                          attrs: { content: story.description },
                                        },
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(story.description) +
                                              "\n                        "
                                          ),
                                        ]
                                      ),
                                  _vm._v(" "),
                                  _c("ECharts", {
                                    staticClass: "echart-graph",
                                    attrs: {
                                      option: _vm.lineBar(
                                        story.meta.last7DaysUsages
                                      ),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.checkPermission(
                  _vm.PERMISSION_TYPES["chatbot.templates.view"].tr.name
                )
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.modalVisible,
                            expression: "!modalVisible",
                          },
                        ],
                        staticClass: "section-templates",
                        class: { akinon: _vm.akinonEnabled },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "section-templates-header" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "section-templates-header-text",
                                attrs: {
                                  "text-type": "h2",
                                  "text-weight": "semi-bold",
                                },
                              },
                              [
                                _c("span", { staticClass: "material-icons" }, [
                                  _vm._v(" tips_and_updates "),
                                ]),
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$t("message.useReadyTemplates")
                                    ) +
                                    "\n                    "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a-button",
                              {
                                attrs: { type: "primary", ghost: "" },
                                on: { click: _vm.gotoTemplatePage },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("message.checkMore")) +
                                    "\n                    "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("Templates", {
                          attrs: {
                            "show-search": false,
                            "show-side-bar": false,
                            "enabled-slugs": _vm.akinonEnabled
                              ? ["us-polo-assn", "pierre-cardin", "cacharel"]
                              : [
                                  "online-quiz-bot",
                                  "call-scheduling",
                                  "university-bot",
                                ],
                            "page-mode": false,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.modalVisible
            ? _c("CreateChatbot", {
                on: {
                  close: function () {
                    return (_vm.modalVisible = false)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }